import { render, staticRenderFns } from "./AddProductSubcategoryComponent.vue?vue&type=template&id=c0657dbc&scoped=true"
import script from "./AddProductSubcategoryComponent.vue?vue&type=script&lang=js"
export * from "./AddProductSubcategoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0657dbc",
  null
  
)

export default component.exports